import React, { useRef } from 'react';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { Menu } from '@jbrowse/core/ui';
// local utils
import { SCALE_BAR_HEIGHT } from '..';
import { useSideScroll, useRangeSelect, useWheelScroll } from './hooks';
// local components
import Rubberband from './Rubberband';
import Scalebar from './Scalebar';
import Gridlines from './Gridlines';
import CenterLine from './CenterLine';
import VerticalGuide from './VerticalGuide';
import RubberbandSpan from './RubberbandSpan';
var useStyles = makeStyles()({
  tracksContainer: {
    position: 'relative',
    overflow: 'hidden'
  },
  spacer: {
    position: 'relative',
    height: 3
  }
});
function TracksContainer(_ref) {
  var children = _ref.children,
    model = _ref.model;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var _useSideScroll = useSideScroll(model),
    mouseDown1 = _useSideScroll.mouseDown,
    mouseUp = _useSideScroll.mouseUp;
  var ref = useRef(null);
  var _useRangeSelect = useRangeSelect(ref, model, true),
    guideX = _useRangeSelect.guideX,
    rubberbandOn = _useRangeSelect.rubberbandOn,
    leftBpOffset = _useRangeSelect.leftBpOffset,
    rightBpOffset = _useRangeSelect.rightBpOffset,
    numOfBpSelected = _useRangeSelect.numOfBpSelected,
    width = _useRangeSelect.width,
    left = _useRangeSelect.left,
    anchorPosition = _useRangeSelect.anchorPosition,
    handleMenuItemClick = _useRangeSelect.handleMenuItemClick,
    open = _useRangeSelect.open,
    handleClose = _useRangeSelect.handleClose,
    mouseMove = _useRangeSelect.mouseMove,
    mouseDown2 = _useRangeSelect.mouseDown;
  useWheelScroll(ref, model);
  return React.createElement("div", {
    ref: ref,
    "data-testid": "trackContainer",
    className: classes.tracksContainer,
    onMouseDown: function onMouseDown(event) {
      mouseDown1(event);
      mouseDown2(event);
    },
    onMouseMove: mouseMove,
    onMouseUp: mouseUp
  }, model.showGridlines ? React.createElement(Gridlines, {
    model: model
  }) : null, model.showCenterLine ? React.createElement(CenterLine, {
    model: model
  }) : null, guideX !== undefined ? React.createElement(VerticalGuide, {
    model: model,
    coordX: guideX
  }) : rubberbandOn ? React.createElement(RubberbandSpan, {
    leftBpOffset: leftBpOffset,
    rightBpOffset: rightBpOffset,
    numOfBpSelected: numOfBpSelected,
    width: width,
    left: left
  }) : null, anchorPosition ? React.createElement(Menu, {
    anchorReference: "anchorPosition",
    anchorPosition: {
      left: anchorPosition.clientX,
      top: anchorPosition.clientY
    },
    onMenuItemClick: handleMenuItemClick,
    open: open,
    onClose: handleClose,
    menuItems: model.rubberBandMenuItems()
  }) : null, React.createElement(Rubberband, {
    model: model,
    ControlComponent: React.createElement(Scalebar, {
      model: model,
      style: {
        height: SCALE_BAR_HEIGHT,
        boxSizing: 'border-box'
      }
    })
  }), children);
}
export default observer(TracksContainer);